import Uppy from '@uppy/core';
import { DragDrop, StatusBar } from '@uppy/react';
import Tus from '@uppy/tus'; 
import { useEffect, useState } from 'react';
import { API_URL } from '../../config/constants';

import { toast } from 'react-toastify';

import '@uppy/core/dist/style.min.css';
import '@uppy/drag-drop/dist/style.min.css';
import '@uppy/status-bar/dist/style.min.css';
import { randomUid } from '../../utils/utils';
import { loadOperations } from '../../services/global/globalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectTranslations } from '../../services/i18n/i18nSlice';

const customFutureDate = (minutes) => {
    const _current_date = new Date()
    return new Date(_current_date.getTime() + minutes*60000);
}

export default function VideoUploader ({folderId, uploader_id=randomUid(), onUpload, onUploadEnd}) {

    const dispatch = useDispatch()
    const t = useSelector(selectTranslations)

    const [uppy] = useState( () => new Uppy({debug: true, autoProceed:true})
        .use(Tus, {  
            id: uploader_id,
            endpoint: `${API_URL}/initialize_video_upload${folderId ? '?folder_id='+folderId : ""}`, 
            withCredentials: false,
            credentials: "",
            chunkSize: 150 * 1024 * 1024,
            onBeforeRequest: function (req) {
                var xhr = req.getUnderlyingObject()
                if(req.getMethod() === 'POST'){
                    xhr.withCredentials = true
                }
                else
                    xhr.withCredentials = false
            },
            onAfterResponse: function(req, res) {
                if(res?._xhr?.response){
                    let _response = structuredClone(res?._xhr?.response)
                    _response = JSON.parse(_response)
                    if(res?._xhr?.status !== 200){
                        if(_response?.detail === "uploaded video size exceeds maximum allowed video size")
                            toast.error(t.upload.file_too_big)
                        else
                            toast.error(t.upload.error_upload)
                    } else
                        onUpload(_response)
                }
            },
            onShouldRetry(err, retryAttempt, options, next) {
                if (err?.originalResponse?.getStatus() === 400) {
                    console.log("Errore upload");
                    return false;
                }
                return next(err);
            }
        })
        .on('upload-success',(e)=>{
            toast.success('Video caricato con successo')
            dispatch(loadOperations())
            onUploadEnd(e)
        })
    );

    useEffect(()=>{
        uppy.setMeta({'maxDurationSeconds': 180*60, 'expiry': customFutureDate(15).toISOString().substring(0,19)+'Z'})
    },[])

    return(
        <div>
            <DragDrop uppy={uppy} />
            <StatusBar uppy={uppy}/>
        </div>
    )

}

